export const getCustomerFromJwt = (token: string) => {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    let body = JSON.parse(jsonPayload);
    return body.user?.customer /*ACTION TOKEN*/ ?? body[body.aud + '/app']?.customer;
  } catch {
    return '';
  }
};

export const getUserIdFromJwt = (token: string): string | null => {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    let body = JSON.parse(jsonPayload);
    let userId = body.user?.user_id /*USER ID*/ ?? body[body.aud + '/app']?.user_id;
    return userId ?? null;
  } catch {
    return null;
  }
};
